module.exports = __webpack_public_path__ + "img/card-contract-editor-hover.c117fb1b.svg";